import { useEffect, useState, useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useStore } from "../../../Components/StateProvider";
import {
    baseurl,
    URLPRIFIX,
    GetStatusCounts,
    ErrorAlert
} from "../../../functions/api";
import {
    URL_Account_Receipt_List,
} from "../../../Constancs/apiconst";
import axios from "axios";
import { getlocal } from "../../../functions/localstorage";
import StatusTabs from "../../../Components/Elements/StatusTabs";
import Pagination from "../../../Components/Fields/Pagination";
import ListViewUp from "../../../Components/Elements/ListViewUp";


const ListView = ({
    header,
    filteredRecords,
    Tablehead,
    Tablerecord,
    sortConfig,
    handleSort,
    filters,
    onFilterChange,
    store,
    handleOnSelect,
    isSelected,
    handleClickRow,
    handleDelete,
    handleSelectAll,
    isAllSelected,
    tablename,
    currentPage = 1,
    pageSize = 20,
}) => {
    const getStatusColorClass = (status) => {
        switch (status) {
            case "Completed":
                return "bg-[#f4ecf7] text-[#212f3d]";
            case "Paid with TDS":
                return "bg-[#E6F4EA] text-[#188038]";
            case "Paid":
                return "bg-[#E6F4EA] text-[#188038]";
            case "Awaiting TDS":
                return "bg-[#f9e79f] text-[#212f3d]";
            case "Cancelled":
                return "bg-[#ffcccb] text-[#cc0000]";
            case "Draft":
                return "bg-[#d6eaf8] text-[#21618c]";
            default:
                return "bg-gray-200"; // Default color
        }
    };

    return (
        <div
            className={`flex  overflow-auto `}
            style={{ height: '90%', width: '100%' }}
        >
            <div className="origin-top-left scale-[0.8] min-w-[125%]">
                <table className="table-auto w-full h-fit">
                    <thead className="sticky top-0 bg-secondary text-left mt-10 border-b">
                        <tr className="px-1">
                            <th className={Tablehead}>
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={isAllSelected}
                                    className="w-[12px] h-[18px]"
                                />
                            </th>
                            <th className={Tablehead}>
                                S.No.
                                <input type="text" className="invisible w-[6px] h-[12px]" readOnly />
                            </th>
                            {header.map(([name, label], index) => {
                                if (label !== "id" && label !== "ACTION" && label !== "select" && label !== "invoice_status") {
                                    return (
                                        <th key={index} className={Tablehead}>
                                            <div
                                                className="flex flex-col cursor-pointer"
                                                onClick={() => handleSort(label)}
                                            >
                                                <div className="flex items-center justify-between">
                                                    <span>{name}</span>
                                                    {sortConfig.field === label && (
                                                        <span>{sortConfig.direction === "asc" ? "↑" : "↓"}</span>
                                                    )}
                                                </div>
                                                <div className="relative w-full">
                                                    <input
                                                        type={label.toLowerCase().includes("date") ? "date" : "text"}
                                                        placeholder='-'
                                                        className=" text-sm w-full"
                                                        value={filters[label] || ""}
                                                        onClick={(e) => e.stopPropagation()}
                                                        onChange={(e) => onFilterChange(label, e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </th>
                                    );
                                } else if (label === "invoice_status") {
                                    // Render only the header for invoice_status here
                                    return (
                                        <th key={index} className={Tablehead}>
                                            <div
                                                className="flex flex-col cursor-pointer"
                                                onClick={() => handleSort(label)}
                                            >
                                                <div className="flex items-center justify-between">
                                                    <span>{name}</span>
                                                    {sortConfig.field === label && (
                                                        <span>{sortConfig.direction === "asc" ? "↑" : "↓"}</span>
                                                    )}
                                                </div>
                                                <div className="relative w-full">
                                                    <input
                                                        type="text" // Input type for filtering status
                                                        placeholder='-'
                                                        className=" text-sm w-full"
                                                        value={filters[label] || ""}
                                                        onClick={(e) => e.stopPropagation()}
                                                        onChange={(e) => onFilterChange(label, e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </th>
                                    );
                                }
                                else if (
                                    label === "ACTION" &&
                                    (store.getprops("update") || store.getprops("view") || store.getprops("delete"))
                                ) {
                                    return (
                                        <th key={index} className={`${Tablehead} font-bold px-2 py-2`}>
                                            <div className="flex flex-col gap-1 w-full">
                                                <span className="font-bold">{name}</span>
                                                <input type="text" className=" w-[8px] h-[24px]" readOnly />
                                            </div>
                                        </th>
                                    );
                                }
                                return null;
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredRecords.map((item, index) => (
                            <tr
                                key={item.id || index}
                                className={
                                    "border-b h-8 hover:bg-[#b3b3f5] rounded-xl cursor-pointer " +
                                    (item?.error && ` bg-red bg-opacity-35 `) +
                                    (isSelected(item) ? " bg-blue-100 " : "")
                                }
                            >
                                <td
                                    className={
                                        Tablerecord + " flex justify-center items-center h-full"
                                    }
                                >
                                    <input
                                        type="checkbox"
                                        onChange={(event) => {
                                            handleOnSelect(item, event.target.checked);
                                        }}
                                        checked={isSelected(item)}
                                    />
                                </td>
                                <td className={Tablerecord}>
                                    {(currentPage - 1) * pageSize + index + 1}
                                </td>

                                {header.map(([name, label], fieldindex) => {
                                    if (label === "ACTION") {
                                        if (store.getprops("update") || store.getprops("delete")) {
                                            return (
                                                <td key={fieldindex} className={Tablerecord}>
                                                    <div className="flex gap-7">
                                                        {store.getprops("update") && (
                                                            <img
                                                                src="/Assets/images/pencil.png"
                                                                className=" cursor-pointer w-5 h-5 hover:scale-125"
                                                                onClick={() => {
                                                                    store.navTo(
                                                                        `/${URLPRIFIX}/${tablename}/edit/${item.id}`
                                                                    );
                                                                }}
                                                            />
                                                        )}
                                                        {store.getprops("delete") && (
                                                            <img
                                                                src="/Assets/images/trash.png"
                                                                className=" cursor-pointer w-5 h-5 hover:scale-125"
                                                                onClick={() => handleDelete(item)}
                                                            />
                                                        )}
                                                    </div>
                                                </td>
                                            );
                                        }
                                    } else if (label === "activeStatus") {
                                        return (
                                            <td key={fieldindex} className={Tablerecord}>
                                                {item[label] ? "Active" : "Inactive"}
                                            </td>
                                        );
                                    } else if (label.toLowerCase().includes("date")) {
                                        const dateValue = item[label];
                                        let displayDate = "---";

                                        if (typeof dateValue === "string" && dateValue) {
                                            const [date] = dateValue.split("T");
                                            displayDate = date;
                                        }

                                        return (
                                            <td
                                                key={fieldindex}
                                                className={Tablerecord}
                                                onClick={() => {
                                                    handleClickRow && handleClickRow(item);
                                                }}
                                            >
                                                {displayDate}
                                            </td>
                                        );
                                    } else if (label === "invoice_status") { // THIS IS THE CORRECT PLACE
                                        const statusClass = getStatusColorClass(item[label]);
                                        return (
                                            <td key={fieldindex} className={Tablerecord}>
                                                <span
                                                    className={`${statusClass} px-2 py-1 rounded-full text-xs`}
                                                    onClick={() => {
                                                        handleClickRow && handleClickRow(item); // Changed from onclick to handleClickRow for consistency
                                                    }}
                                                >
                                                    {item[label]}
                                                </span>
                                            </td>
                                        );
                                    }
                                    else if (label !== "id" && label !== "select") {
                                        return (
                                            <td
                                                key={fieldindex}
                                                className={Tablerecord}
                                                onClick={() => {
                                                    handleClickRow && handleClickRow(item);
                                                }}
                                            >
                                                {item[label]?.toString()?.charAt(0)?.toUpperCase() +
                                                    item[label]?.toString()?.slice(1)}
                                            </td>
                                        );
                                    }
                                    return null;
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const ReceiptListUpdated = () => {
    const location = useLocation();
    const { companyId } = useParams();
    const queryParams = new URLSearchParams(location.search);
    const tablename = "companies";
    const statusCountURL = "/api/v2/paymentreceipt/getpaymentreceiptstatuscount/" + companyId;
    const [statusTabs, setStatusTabs] = useState([]);
    const [activeTab, setActiveTab] = useState("ALL");
    const [filters, setFilters] = useState({});
    const [hasTabClicked, setHasTabClicked] = useState(false);
    const [sortConfig, setSortConfig] = useState({ field: null, direction: 'asc' });
    const [selectedRecords, setSelectedRecords] = useState([]);


    const Header = [
        ["Receipt Number", "receipt_no"],
        ["Amount Received", "amount"],
        ["Customer Name", "customer_name"],
        // ["Status", "receipt_status"],
        ["Receipt Date", "receiptdate"],

        ["Action", "ACTION"],
    ];
    const store = useStore();
    const init = {
        filterfield: "all",
        search: "",
        sort: "desc",
        currentpage: 1,
        totalpage: 1,
        pagesize: 20,
    };

    // State for filtered records that will be passed to ListView
    const [filteredRecords, setFilteredRecords] = useState([]);

    useEffect(() => {
        store.setmodule("receipts", init).then(() => {
            fetchStatusCounts();
            store.stopLoading();
            store.setheader(tablename + " List");
            var states = store.state.records.receipts;
            GetListview({
                listUrl: URL_Account_Receipt_List + companyId,
                store: store,
                field: queryParams.get("field") || states?.filterfield,
                search: queryParams.get("search") || states?.search,
                sort: queryParams.get("sort") || states?.sort,
                pagesize: queryParams.get("pagesize") ?? store.getvalue("pagesize") ?? init.pagesize,

            });
        });
    }, [companyId]);

    const fetchStatusCounts = useCallback(async () => {
        store.startLoading();
        try {
            const counts = await GetStatusCounts(statusCountURL, store);
            if (counts?.statuscount) {
                setStatusTabs(counts.statuscount);
            }
        } catch {
            console.log("Failed to fetch Receipt status counts.");

            ErrorAlert("Failed to fetch status counts.");
        } finally {
            store.stopLoading();
        }
    }, [statusCountURL, store]);

    const handleSort = useCallback((field) => {
        let direction = 'asc';
        if (sortConfig.field === field && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ field, direction });

        change({
            field: field,
            search: filters[field] || "", // Use existing filter for the field
            sort: direction,
            page: store.getvalue("currentpage") || 1,
            pagesize: store.getvalue("pagesize") // Maintain current page
        });
    }, [sortConfig, filters, store]);

    const handleFilterChange = useCallback((field, value) => {
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: value,
        }));

        // Trigger data fetch with new filter value
        change({
            field: field,
            search: value,
            sort: sortConfig.direction,
            page: 1, // Reset to first page on filter change
        });
    }, [sortConfig, store]);


    function change(props) {
        console.log("search data - ", props);
        GetListview({
            listUrl: URL_Account_Receipt_List + companyId,
            store: store,
            field: props.field,
            search: props.search,
            sort: props.sort,
            page: props.page || store.getvalue("currentpage") || 1,
            pagesize: props.pagesize || store.getvalue("pagesize") || init.pagesize,
        });
    }

    function onpage(page, newSize = store.getvalue("pagesize")) {
        const currentFilters = store.getvalue("filters") || {};
        const filterField = Object.keys(currentFilters)[0] || "all";
        const filterSearch = currentFilters[filterField] || "";

        GetListview({
            listUrl: URL_Account_Receipt_List + companyId,
            store: store,
            field: filterField,
            search: filterSearch,
            sort: sortConfig.direction,
            page: page,
            pagesize: newSize, // Pass the new size from pagination component
        });
    }

    function GetListview({
        listUrl = "",
        field = "",
        search = "",
        sort = "",
        page = 1,
        count = 20, // This 'count' parameter seems unused in the URL construction for pagination logic
        pagesize = 20,
        store,
    }) {
        let token = getlocal("system").token;
        let url = "";
        if (field !== "") url += "&fieldname=" + field;
        if (search !== "") url += "&search=" + search;
        if (sort !== "") url += "&sort=" + sort;
        if (page !== "") url += "&page=" + page;
        if (count !== "") url += "&count=" + count; // This might be problematic if 'count' is meant to be the total count, but 'pagesize' is used for pagination.
        if (pagesize !== "") url += "&pagesize=" + pagesize;
        url = url.substring(1, url.length);
        url = `${baseurl}${listUrl}?${url}`;

        axios
            .get(url, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                console.log("GetListview responce - ", res);
                res = res?.data;

                console.log("check1", res)
                // Ensure totalCount from the API is a number, default to 0 if not present
                const totalItems = res?.totalCount ? parseInt(res.totalCount, 10) : 0;
                console.log("check2 totalitems", totalItems)

                const currentPagesize = pagesize > 0 ? pagesize : init.pagesize;
                console.log("check3 currentpagesize", totalItems)



                let totalPages = 0;
                if (currentPagesize > 0) { // Prevent division by zero
                    totalPages = Math.ceil(totalItems / currentPagesize);
                }

                // transformedList and other logic remain the same
                const transformedList = res.list.map((item) => {
                    // ... (your existing switch case for invoice_status)
                    switch (item.invoice_status) {
                        case "paid":
                            item.invoice_status = "Paid";
                            break;
                        case "awaitingtds":
                            item.invoice_status = "Awaiting TDS";
                            break;
                        case "completed":
                            item.invoice_status = "Completed";
                            break;
                        case "cancelled":
                            item.invoice_status = "Cancelled";
                            break;
                        case "paidwithtds":
                            item.invoice_status = "Paid with TDS";
                            break;
                        case "draft":
                            item.invoice_status = "Draft";
                            break;
                        default:
                            item.invoice_status = "Unknown";
                            break;
                    }
                    return item;
                });

                store.setvalue("totalpage", totalPages); // This stores the calculated number of pages
                store.setvalue("currentpage", page);
                store.setvalue("pagesize", currentPagesize); // Ensure pagesize is correctly set in store
                store.setvalue("list", transformedList);
                // Also store the total number of items, which the Pagination component might need
                store.setvalue("totalrecords", totalItems); // <-- Add this
                setFilteredRecords(transformedList);
            })
            .catch((res) => {
                console.log("Error Response", res);
                // Optionally, set default values to prevent NaN in pagination on error
                store.setvalue("totalpage", 1);
                store.setvalue("currentpage", 1);
                store.setvalue("pagesize", init.pagesize);
                store.setvalue("totalitems", 0);
                setFilteredRecords([]);
            });
    }

    const handleTabClick = useCallback((status, count) => {
        console.log("tab clicked", status);
        console.log("tab clicked count", count);

        const field = "invoice_status";
        const search = status.toUpperCase() === "ALL" ? "" : status;
        setActiveTab(status);
        setHasTabClicked(true);
        store.setvalue("ActiveTab", status);
        store.setvalue("TabClicked", true);
        // store.setvalue("pagesize", count); // Remove or comment out this line

        const newFilters = status.toUpperCase() === "ALL" ? {} : { [field]: search };
        setFilters(newFilters);
        store.setvalue("filters", newFilters);

        GetListview({
            listUrl: URL_Account_Receipt_List + companyId,
            store: store,
            field: field,
            search: search,
            sort: sortConfig.direction,
            page: 1,
            pagesize: count, // Pass the 'count' directly here
        });
    }, []);


    const handleClearFilter = useCallback(() => {
        setActiveTab("ALL");
        setFilters({});
        setHasTabClicked(false);
        store.setvalue("filters", {});
        store.setvalue("pagesize", init.pagesize);
        store.setvalue("filterfield", init.filterfield);
        store.setvalue("search", init.search);
        store.setvalue("sort", init.sort);
        store.setvalue("currentpage", init.currentpage);
        store.setvalue("ActiveTab", "ALL");
        store.setvalue("TabClicked", false);

        // Call GetListview to refetch all records without filters
        GetListview({
            listUrl: URL_Account_Receipt_List + companyId,
            store: store,
            field: init.filterfield,
            search: init.search,
            sort: init.sort,
            page: init.currentpage,
            pagesize: init.pagesize,
        });
    }, [companyId, store, init]);


    const handleDeleteRecord = useCallback(async (item) => {
        if (window.confirm(`Are you sure you want to delete invoice no. ${item.invoice_no}?`)) {
            store.startLoading();
            try {
                // const token = getlocal("system").token;
                // const deleteUrl = `${baseurl}${DeleteURL}${item.id}`; // Assuming DeleteURL is defined
                // await axios.delete(deleteUrl, {
                //     headers: { Authorization: `Bearer ${token}` },
                // });
                // ErrorAlert("Invoice deleted successfully!");
                // Re-fetch data after deletion
                // onpage(store.getvalue("currentpage"));
            } catch (error) {
                console.error("Error deleting invoice:", error);
                ErrorAlert("Failed to delete invoice.");
            } finally {
                store.stopLoading();
            }
        }
    }, [store, onpage]); // Added DeleteURL to dependencies

    const handleRowClick = useCallback((item) => {
        // This function will be called when a row is clicked (excluding checkbox and action buttons)
        if (store.getprops("view")) {
            store.navTo(
                "/" +
                URLPRIFIX +
                "/" +
                companyId +
                "/accounts/receipt/view/" +
                item.id
            );
        }
    }, [companyId, store]);

    const handleOnSelect = useCallback((record, isChecked) => {
        setSelectedRecords((prevSelected) => {
            if (isChecked) {
                return [...prevSelected, record];
            } else {
                return prevSelected.filter((item) => item.id !== record.id);
            }
        });
    }, []);

    const isSelected = useCallback((record) => {
        return selectedRecords.some((item) => item.id === record.id);
    }, []);

    const handleSelectAll = useCallback((event) => {
        if (event.target.checked) {
            setSelectedRecords(filteredRecords);
        } else {
            setSelectedRecords([]);
        }
    }, []);

    const isAllSelected = filteredRecords.length > 0 && selectedRecords.length === filteredRecords.length;
    const Tablehead =
        " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[16px] xl:text-[20px] font-bold ";
    const Tablerecord =
        " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[12px] xl:text-[16px] overflow-hidden";

     return (
        <div className="grid grid-rows-10 h-full ">
      <div className="flex flex-wrap justify-between items-center mb-2 m-8 px-2">
                <StatusTabs
                    statusTabs={statusTabs}
                    activeTab={activeTab}
                    onTabClick={handleTabClick}
                    hasTabClicked={hasTabClicked}
                    onClearClick={handleClearFilter}
                />
                {store.getprops("add") && (
                    <div className="absolute right-10 top-5">
                        <button
                            className="bg-primary text-secondary px-3 py-1 rounded-full border-2 transition text-sm"
                            onClick={() => {
                                store.removemodule(
                                    tablename.substring(0, tablename.length - 1)
                                );
                                store.navTo(
                                    "/" + URLPRIFIX + "/" + companyId + "/accounts/receipt/create"
                                );
                            }}
                        >
                            ➕ ADD RECEIPT
                        </button>
                    </div>
                )}
            </div>
            <div className="row-span-9 h-full w-full ">
                <div className="py-5 px-[30px] h-full  w-full" contentEditable={false}>
                    <ListView
                        header={Header}
                        filteredRecords={filteredRecords} // Pass the local state
                        Tablehead={Tablehead} // Example class, adjust as needed
                        Tablerecord={Tablerecord} // Example class, adjust as needed
                        sortConfig={sortConfig}
                        handleSort={handleSort}
                        filters={filters}
                        onFilterChange={handleFilterChange}
                        store={store}
                        handleOnSelect={handleOnSelect}
                        isSelected={isSelected}
                        handleClickRow={handleRowClick} // Pass the new row click handler
                        handleDelete={handleDeleteRecord} // Pass the delete handler
                        handleSelectAll={handleSelectAll}
                        isAllSelected={isAllSelected}
                        tablename="receipts" // Changed to "receipts" as it's an invoice list
                        currentPage={store.getvalue("currentpage")}
                        pageSize={store.getvalue("pagesize")}
                    />

                    <div className="float-right mr-8 mt-6">
                        <Pagination onchange={onpage} />
                    </div>
                </div>
            </div>
        </div>
    );

};

export default ReceiptListUpdated;

